import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getManagementRoundSchema } from '../../../redux/actions/adminProjectManagemant'
import ManageConsiderationRoundWidget from '../../../widgets/manageConsiderationRound/ManageConsiderationRoundWidget'

export default function ManageConsiderationRound() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManagementRoundSchema()
      setSchema(_schema)
      // setSchema(mockschema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms?.considerationRound && (
        <>
          <ManageConsiderationRoundWidget schema={schema.forms.considerationRound} />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
